import { AmplitudeExperimentIds, AmplitudeExperimentsVariantIds } from '../AmplitudeExperiments';
import { useAmplitudeFeatureFlag } from './useAmplitudeExperiments';
import { useEffect } from 'react';

/**
 * Do not use this function directly! Use the corresponding experiment's hooks.
 */
export const useAmplitudeExperimentBase = (
    featureFlagKey: AmplitudeExperimentIds,
    featureFlagVariant: AmplitudeExperimentsVariantIds[typeof featureFlagKey]
) => {
    const { isShowingFeature, trackFeatureFlag } = useAmplitudeFeatureFlag(featureFlagKey, featureFlagVariant);

    useEffect(() => {
        // Track exposure regardless of variant to ensure proper experiment analysis
        trackFeatureFlag();
    }, [featureFlagKey, featureFlagVariant, isShowingFeature, trackFeatureFlag]);

    return isShowingFeature;
};
